import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAllemailTemplatesStart, getImageGalleryStart, resetEmailTemplate } from '../../../../store/redux-slices/emailTemplate'
import useCheckPermission from '../../../../utils/checkPermission'
import { getLanguagesStart } from '../../../../store/redux-slices/languages'

const useEmailTemplate = () => {
  const dispatch = useDispatch()
  const [show, setShow] = useState(false)
  const [lang, setLang] = useState('EN')
  const [type, setType] = useState('EN')
  const [templateData, setTemplateData] = useState('')
  const { languages } = useSelector(state => state.languages)
  const { isHidden } = useCheckPermission()
  const setModalData = (key, template) => {
    setType(key)
    setTemplateData(template)
    setShow(true)
  }

  const { emailTemplate, emailTemplates, loading, emailTemplateOrder } = useSelector((state) => state.emailTemplate)

  useEffect(() => {
    dispatch(getAllemailTemplatesStart({}))
    dispatch(getLanguagesStart({ limit: '', pageNo: '', name: '' }))
    !isHidden({ module: { key: 'ImageGallery', value: 'R' } }) &&
      dispatch(getImageGalleryStart({ isTenant: false }))
  }, [])
  const resetEmail = () => dispatch(resetEmailTemplate())

  return {
    emailTemplate,
    emailTemplates,
    loading,
    show,
    setShow,
    setModalData,
    templateData,
    isHidden,
    emailTemplateOrder,
    lang,
    setLang,
    languages,
    type,
    resetEmail
  }
}

export default useEmailTemplate
